export default function setupRouterGuards(router) {
    router.beforeEach((to, from, next) => {
        if (to.path === '/login' || to.path.startsWith('/training_evaluate')) {
            next()
        } else {
            if (window.localStorage.getItem('accessToken') !== 'null' && window.localStorage.getItem('accessToken') !== null && window.localStorage.getItem('accessToken') !== undefined) {
                if (to.path === '/') {
                    next('/notifications')
                } else {
                    next()
                }
            } else {
                 // ✅ Save the intended route before redirecting to login
                window.localStorage.setItem('redirectAfterLogin', to.fullPath)
                next('/login')
            }
        }
    })
}